import { app } from '../../core/App';
import { Sounds } from '../../sounds';
import { SoundBanks } from '../../sound-banks';
import { RoadDetails } from '../level/themes/theme';
import { VehicleManager } from './VehicleManager';
import { DriverProfile, Vehicle, VehicleDetails, VehicleHandling } from './Vehicle';
import { Character, CharacterName } from './Character';
import { EquipmentType, EquipmentTypeValues } from './VehicleEquipment';
import { VehicleEquipmentWeapon } from './VehicleEquipmentWeapon';
import { VehicleWeaponGlove } from './equipment-weapon/VehicleWeaponGlove';
import { VehicleWeaponShockWave } from './equipment-weapon/VehicleWeaponShockWave';
import { VehicleWeaponSkyWriting } from './equipment-weapon/VehicleWeaponSkyWriting';
import { VehicleWeaponInk } from './equipment-weapon/VehicleWeaponInk';
import { VehicleWeaponSnowBlower } from './equipment-weapon/VehicleWeaponSnowBlower';

export class VehicleVillain extends Vehicle {
  protected weapon: VehicleEquipmentWeapon | undefined;

  protected shouldLift: boolean;
  protected liftSpeedX: number;
  protected liftSpeedY: number;

  protected moneySpawnOffsetX: number;
  protected moneySpawnOffsetY: number;
  protected moneyOffsetY: number;
  protected presentSpawnOffsetX: number;
  protected presentSpawnOffsetY: number;

  protected camera: Phaser.Cameras.Scene2D.Camera;
  protected trackCameraX: boolean;
  protected trackCameraY: boolean;
  protected cameraDistanceX: number;

  constructor(
    scene: Phaser.Scene,
    vehicleManager: VehicleManager,
    driverProfile: DriverProfile,
    vehicleHandling: VehicleHandling,
    roadDetails: RoadDetails,
    vehicleDetails: VehicleDetails
  ) {
    super(scene, vehicleManager, driverProfile, vehicleHandling, roadDetails, vehicleDetails);

    this.shouldLift = false;
    this.liftSpeedX = -3.25 / 16.666;
    this.liftSpeedY = -6 / 16.666;

    this.moneySpawnOffsetX = 0;
    this.moneySpawnOffsetY = -20;
    this.moneyOffsetY = -20;
    this.presentSpawnOffsetX = 0;
    this.presentSpawnOffsetY = 150;

    if (this.driverProfile.driver == CharacterName.Jestah) {
      this.moneySpawnOffsetX = -50;
      this.moneySpawnOffsetY = -80;
    } else if (this.driverProfile.driver == CharacterName.Quizz) {
      this.moneySpawnOffsetX = 20;
      this.moneySpawnOffsetY = -40;
      this.moneyOffsetY = 0;
      this.presentSpawnOffsetX = 0;
      this.presentSpawnOffsetY = -60;
    }

    this.camera = this.scene.cameras.main;
    this.trackCameraX = false;
    this.trackCameraY = false;
    this.cameraDistanceX = 500;

    this.setupEquipment(this.driverProfile.equipment);
  }

  get Weapon(): VehicleEquipmentWeapon | undefined {
    return this.weapon;
  }

  get MoneySpawnOffsetX(): number {
    return this.moneySpawnOffsetX;
  }
  get MoneySpawnOffsetY(): number {
    return this.moneySpawnOffsetY;
  }
  get MoneyOffsetY(): number {
    return this.moneyOffsetY;
  }

  get PresentSpawnOffsetX(): number {
    return this.presentSpawnOffsetX;
  }
  get PresentSpawnOffsetY(): number {
    return this.presentSpawnOffsetY;
  }

  public setCameraDistance(newDistance: number) {
    this.cameraDistanceX = newDistance;
  }

  public toggleTrackX(shouldTrack: boolean) {
    this.trackCameraX = shouldTrack;
  }

  public toggleTrackY(shouldTrack: boolean) {
    this.trackCameraY = shouldTrack;
  }

  public startWarning() {
    app.audioHandler.playSound(this.scene, this.sounds.prefire, Sounds.Channel.SFX, { volume: 1.0 });
    this.CharacterSpine.warning();
  }

  public fire() {
    this.weapon?.fire();
    if(this.driverProfile.driver != CharacterName.Jestah && this.driverProfile.driver != CharacterName.Prank)
    {
      app.audioHandler.playSound(this.scene, this.sounds.fire, Sounds.Channel.SFX, { volume: 1.0 });
    }
  }

  public crash() {
    this.shouldControlY = false;

    this.scene.add.tween({
      targets: this,
      y: this.camera.worldView.bottom + 200,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.In
    });
  }

  public onVoice() {
    app.audioHandler.playSound(this.scene, this.sounds.villainVoice, Sounds.Channel.SFX, { volume: 1.0 });
  }

  public startLift() {
    console.log('Start Lift');
    this.shouldLift = true;
  }

  public stopLift() {
    console.log('Stop Lift');
    this.shouldLift = false;

    this.scene.add.tween({
      targets: this.CharacterSpine,
      x: this.CharacterSpine.x - 15,
      y: this.CharacterSpine.y - 20,
      // rotation: -Math.PI * 0.0125,
      duration: 270,
      ease: Phaser.Math.Easing.Cubic.Out,
      yoyo: true,
      repeat: 1,
      repeatDelay: 50,
    });
  }

  public update(time: number, delta: number): void {
    if (this.shouldLift) {
      this.CharacterSpine.x += this.liftSpeedX * delta;
      this.jumpOffsetY += this.liftSpeedY * delta;
    }

    if (this.trackCameraX) {
      let diffX = this.x - this.camera.worldView.centerX;

      if (diffX > this.cameraDistanceX) this.decelerateX();
      else this.accelerateX();
    }

    if (this.trackCameraY && this.vehicleManager.HeroVehicle) {
    }

    super.update(time, delta);
  }

  protected setupEquipment(equipment: EquipmentTypeValues[]) {
    for (const equipmentType of equipment) {
      switch (equipmentType) {
        case EquipmentType.BoxingGlove:
          let glove = new VehicleWeaponGlove(this.scene, this, this.scene.cameras.main, this.character);
          glove.toggleRun(true);
          this.weapon = glove;
          this.equipment.push(this.weapon);
          break;
        case EquipmentType.GiantMallet:
          let shockWave = new VehicleWeaponShockWave(this.scene, this, this.scene.cameras.main, this.character);
          shockWave.toggleRun(true);
          this.weapon = shockWave;
          this.equipment.push(this.weapon);
          break;
        case EquipmentType.SkyWriting:
          this.weapon = new VehicleWeaponSkyWriting(this.scene, this, this.scene.cameras.main, this.character);
          this.equipment.push(this.weapon);
          break;
        case EquipmentType.Ink:
          this.weapon = new VehicleWeaponInk(this.scene, this, this.scene.cameras.main, this.character);
          this.equipment.push(this.weapon);
          break;
        case EquipmentType.SnowBlower:
          this.weapon = new VehicleWeaponSnowBlower(this.scene, this, this.scene.cameras.main, this.character);
          this.equipment.push(this.weapon);
          break;
        default:
          break;
      }
    }
  }
}
